import DoneIcon from '@mui/icons-material/Done';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import FlatButton from 'components/FlatButton';

const DoneButton = ({ label = 'Done', ...props }) => (
  <FlatButton
    {...props}
    icon={useMemo(
      () => <DoneIcon />,
      [],
    )}
    label={label}
    title={label}
  />
);

DoneButton.propTypes = {
  ...FlatButton.propTypes,
  label: PropTypes.string,
};

export default DoneButton;
